(function StartBooking($, HE) {
    "use strict";


    var form = {
        name: 'HotelBooking',
    };

    $(document).ready(function documentReady()
    {
        HE.Form.registerForm(form);
    });

    form.confirmation = function confirmation(response)
    {


     if (response.data.response_code === 'duplicate_reservation') {


         HE.CustomConfirm({
             body   : response.data.message,
             confirm: function yes() {
                 var selector
                     = '[name="form_component_data[' + form.name + '][dupe_reservation_proceed]"], '
                     + '#dupe_reservation_proceed, '
                     + '#hotelenginebooking-dupe_reservation_proceed';

                 var $jForm = $('form[name="' + form.name + '"]');

                 var $dupeField = $jForm.find(selector);

                 console.log("Duplicate reservation hidden field(s):", $dupeField);

                 if ($dupeField.length === 0) {
                     alert("⚠️ Could not find dupe_reservation_proceed hidden input!");
                     return;
                 }

                 // Set the flag
                 $dupeField.val(1);

                 // Debugging confirmation
                 console.log("dupe_reservation_proceed set to:", $dupeField.val());

                 // Resubmit the form (use trigger for Adzuki event pipeline)
                 setTimeout(function submitFormTimeout() {
                     $jForm.trigger('submit');
                 }, 100);

             }
         });
        }

    };



    $(document).ready(function onDocumentReady() {

        HE.onload('/Hotels/startBooking/', function onStartBookingLoad() {

			var max_time      = 600, // max amount of seconds before we say to retry
				current_timer = 0,
				interval;

            console.log("StartBooking initialized…");

			/**
			 *These are the public keys to each stripe environment
			 */

			/* global Stripe */
			const stripeTestKey = 'pk_test_51R5FXjA8jMnToYv310Kg8tTGxrV9jkR86zh8d4SAy3GZvqTLlj1wNk1Xn6tHJkWNuK7A3rIQxAh1Ka65LkypWQzn00PfRLoHWS';
			const stripeStageKey= 'pk_test_51R5FXuPGMCMJ4WmVLPAmzKCxY0uYvyotlBBs00wkS3Px7u783DbAlcPBG65WGFMqQCSa0IVX20CuVF7mzfHyK8Dr00GRGiMctr';
			const stripeProdKey = 'pk_live_51R5FXjA8jMnToYv3dJqwzsAvcBJudwuMVDBb3Za1agG5B0BPhAKUxUipz2BASYwiaGuZ1C9RtUN7zvhNE0STK3pZ00jacR4KJJ';
			let stripeKey       = null;

			if (HE.dev === true) {
				stripeKey = stripeTestKey;
			} else if (HE.stage === true) {
				stripeKey = stripeStageKey;
			} else {
				stripeKey = stripeProdKey;
			}

			const stripe = Stripe(stripeKey);

			let stripeElements;
			let provider = $('.payment_info').data('provider');


			if (HE.payment_gateway === 'stripe' && provider !== 'sabre') {
				initializeStripe();
				$('#auth-customer').hide();
			}

			let three_d_secure = JSON.parse(localStorage.getItem('three_d_secure'));
			console.log('3DS', three_d_secure);
			localStorage.removeItem('three_d_secure');

			if (three_d_secure && three_d_secure.url) {
				// Add an id so we can attach a load listener
				let iframeHtml = `<iframe id="three-d-secure-iframe" src="${three_d_secure.url}" style="width:100%;height:500px;border:0;" allow="payment publickey-credentials-get fullscreen" ></iframe>`;

				// Update modal size and content, then show it
				$('.modal-dialog').addClass('mw-100 w-75');
				$('.modal').find('.modal-title').text('3D Secure Authentication');
				$('.modal').find('.modal-body').html(iframeHtml);
				$('.modal').modal('show');

				$('.modal').on('shown.bs.modal', function handle3DSecure(e) {
					// Listen for messages from the iframe
					window.addEventListener('message', function secureListener(event) {
						console.log(event.data, 'EVENT DATA');
						if (event.data) {
							switch (event.data.type) {
								case 'fraud_check_passed':
									// Redirect to resume booking
									$('.modal').modal('hide');
									window.location.href = event.data.redirect;
									break;
								case 'fraud_check_fail':
									$('.modal').modal('hide');
									HE.StatusMessage('error', event.data.message);
									break;
								default:
									break;
							}
						}
					});

				});
			}

			function _getPayAmount()
			{
				return parseFloat($('.you-pay').attr('data-amount'));
			}

			function _updateRemainingDue(amount)
			{
				$('.remaining-due')
					.attr('data-amount', amount)
					.html(accounting.formatMoney(amount));
			}

			function _updatePaymentDisplays(amount, paymentOption)
			{
				$('.you-pay').attr('data-amount', amount);

				if (paymentOption === 'pay_later') {
					$('.you-pay').html('$0');
					_updateRemainingDue(amount);
				} else {
					$('.you-pay').html(accounting.formatMoney(amount));
				}
			}

			$('input[name="payment_option"]').on('change', function paymentType() {

				let selectedValue = $('input[name="payment_option"]:checked').val();
				let payAmount     = _getPayAmount();

				if (selectedValue === 'pay_now') {
					// $('.billing_info').show();
					$('.payment_info').show();

					$('.billing_info_title').text('Billing Information');

					$('#hotelbooking-pay_later').val(0);

					if ($('.remaining-due').length) {
						payAmount = parseFloat($('.remaining-due').attr('data-amount'));
					}

					_updatePaymentDisplays(payAmount, 'pay_now');

					$('.you-pay-later').addClass('d-none');

					if (HE.payment_gateway === 'stripe') {
						$('#stripe-customer').show();
						$('#auth-customer').hide();
						initializeStripe();
					}

				} else {

					$('.payment_info').hide();

					if (HE.payment_gateway === 'stripe') {
						$('#stripe-customer').hide();
						$('#auth-customer').show();
						deinitializeStripe();
					}

					$('.billing_info_title').text('Customer Information');

					_updatePaymentDisplays(payAmount, 'pay_later');
					$('.you-pay-later').removeClass('d-none');

					$('#hotelbooking-pay_later').val(1);
				}
			});

			$('#agree').click(function _enableSubmit() {

				if ($(this).prop('checked') === true) {
					$('.submit-booking').removeClass('disabled');
					$('.submit-booking').prop('disabled', null);
				} else {
					$('.submit-booking').addClass('disabled');
					$('.submit-booking').prop('disabled', true);
				}
			});

			$('#hotelbooking-customer-phone').blur(function _reformatPhone() {
				var formatted  = $(this).val().replace(/\W/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

				if ($(this).val().replace(/[^0-9]/g, "").length >= 10) {
					$(this).val(formatted);
				}
			});

			$('.markup').click(function _applyMarkup(e) {
				var markup         = $('#hotelbooking-markup_entry').val(),
					paymentOption  = $('input[name="payment_option"]:checked').val() || 'pay_now',
					you_pay        = _getPayAmount(),
					total_cost     = parseFloat($('.total-cost').attr('data-amount')),
					selling_price  = parseFloat($('.selling-price').attr('data-amount')),
					new_total      = 0,
					new_total_cost = 0;

				e.preventDefault();


				if (markup > 0) {
					// if it's set to percentage, convert to dollars
					if ($('input[name="markup_type"]:checked').val() === 'percentage') {
						markup = (selling_price * (markup / 100)).toFixed(2);
					}

					// check to make sure that the markup falls within the proper range
					if (_checkMarkup(markup, selling_price) === false) {
						HE.StatusMessage('error', "Sorry, the amount you specified is a higher percentage than allowed (" + parseInt($('#hotelbooking-markup_percentages').data('high')) + "%). Please re-enter.");
						$('#hotelbooking-markup_entry').val('');
						$('#hotelbooking-payment-markup').val('');

						$('.remove-markup').trigger("click");
					} else {
						$('.markup-container').removeClass('d-none');

						new_total      = you_pay + parseFloat(markup);
						new_total_cost = total_cost + parseFloat(markup);

						_updatePaymentDisplays(new_total, paymentOption);

						if (paymentOption === 'pay_now') {
							$('.you-pay-later').addClass('d-none');
						}

						if ($('.total-cost').length) {
							$('.total-cost').html(accounting.formatMoney(new_total_cost));
							$('.total-cost').attr('data-amount', new_total_cost);
						}

						$('.markup-amount').html(accounting.formatMoney(markup));

						$('.add-markup').html('+ a markup of ' + accounting.formatMoney(markup));
						$('#hotelbooking-payment-markup').val(markup);
					}
				} else {
					HE.StatusMessage('error', "A markup must be more than 0");
				}
			});

			$('.remove-markup').click(function _removeMarkup(e) {
				var you_pay        = _getPayAmount(),
					paymentOption  = $('input[name="payment_option"]:checked').val() || 'pay_now',
					total_cost     = parseFloat($('.total-cost').attr('data-amount')),
					markup         = $('#hotelbooking-payment-markup').val(),
					new_total      = 0,
					new_total_cost = 0;

				e.preventDefault();

				if (!markup) {
					return;
				}

				new_total = you_pay - parseFloat(markup);

				$('.markup-container').addClass('d-none');
				_updatePaymentDisplays(new_total, paymentOption);

				if ($('.total-cost').length) {
					new_total_cost = total_cost - parseFloat(markup);

					$('.total-cost').html(accounting.formatMoney(new_total_cost));
					$('.total-cost').attr('data-amount', new_total_cost);
				}

				$('.markup-amount').html(0);
				$('#hotelbooking-markup_entry').val('');
				$('#hotelbooking-payment-markup').val('');
				$('.add-markup').html('');
			});

			/* BEGIN signature specific logic */
			$('.signature-check-email').on('keyup', function _checkClient(e) {
				var pax_idx = $(this).data('pax-idx'),
					email   = $(this).val(),
					data    = {
						email: email
					};

				if ($(this).prop('readonly')) {
					// do nothing if in readonly mode
					return false;
				}

				if ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(email)) {
					HE.Ajax.post('/Hotels/signatureClientSearch/', data).then(function _success(response) {
						if (response !== '') {
							$('#signatureClientLabel').html('An existing client was found by the provided email address');
							$('#signatureClientContent').html(response);
							$('.signature-auto-search').removeClass('d-none');

							$('#signatureClient').offcanvas('show');

							$('.signature-client-row').click(function handleClick() {
								var return_data = {
										pax_idx            : pax_idx,
										signature_client_id: $(this).data('signature-client-id'),
										first_name         : $(this).data('first-name'),
										last_name          : $(this).data('last-name'),
										email              : $(this).data('email'),
										phone              : $(this).data('phone')
									};

								_setSignatureClientId(return_data);
							});
						}
					});
				}
			});

			$('.signature-client-search').click(function _searchClients() {
				var pax_idx   = $(this).data('pax-idx'),
					guest_num = (Number(pax_idx)+1);

				HE.Ajax.get('/Hotels/signatureClientLookUp/' + pax_idx).then(function _success(response) {
					$('#signatureClientLabel').html('Look Up an Existing Client for Guest #' + guest_num);
					$('#signatureClientContent').html(response);

					HE.Form.initAjaxForm('SignatureClientLookup');

					$('#signatureClient').offcanvas('show');

					$('.signature-client-lookup').click(function onSearchClick(e) {
						var form_id           = 'signatureclientlookup-',
							$first_name_input = $('#' + form_id + 'first_name'),
							$last_name_input  = $('#' + form_id + 'last_name'),
							$email_input      = $('#' + form_id + 'email'),
							first_name        = $first_name_input.val(),
							last_name         = $last_name_input.val(),
							email             = $email_input.val(),
							post_data         = {
								first_name: first_name,
								last_name : last_name,
								email     : email
							};

						e.preventDefault();

						$('.signature-client-search-results').html('<i class="fas fa-spinner fa-spin me-2"></i> Searching for client...');

						HE.Ajax.post('/Hotels/signatureClientSearch/', post_data).then(function _success(response) {
							var content = 'No results found based on criteria entered';

							// form validation handling
							if (response.error) {
								HE.Form.throwSubmissionError(_getValidationErrorMessage(response.error));
								return;
							}

							if (response !== '') {
								content = response;
							}

							$('.signature-client-search-results').html(content);

							$('.signature-client-row').click(function handleClick() {
								var return_data = {
										pax_idx            : pax_idx,
										signature_client_id: $(this).data('signature-client-id'),
										first_name         : $(this).data('first-name'),
										last_name          : $(this).data('last-name'),
										email              : $(this).data('email'),
										phone              : $(this).data('phone')
									};

								_setSignatureClientId(return_data);
							});
						});
					});
				});
			});

			$('.signature-clear-search').click(function _clearClient() {
				var pax_idx = $(this).data('pax-idx');

				// reset everything
				_resetSignatureClientId(pax_idx);
			});

			$('.submit-booking').click( async function _submitBooking(e) {
				e.preventDefault();

				let paymentGateway = $('.payment_info').data('payment-gateway');
				let paymentOption  = $('input[name="payment_option"]:checked').val();
				let form           = $('form[name="HotelBooking"]');
				let youPay         = _getPayAmount();
				let amount         = Math.round(youPay * 100);

				if (!paymentOption) {
					paymentOption = 'pay_now';
				}

				if (paymentGateway === 'stripe' && paymentOption === 'pay_now' && provider !== 'sabre') {
					let pi_field      = $('#hotelbooking-payment_intent').val();
					console.log(pi_field, 'Payment Intent Field');
					const handleError = (error) => {
						console.error(error);
						this.disabled = false; // Re-enable button on error
					};

					if (this.disabled) {
						return;
					}

					this.disabled = true;

					try {
						// Trigger form validation and wallet collection
						const {error: submitError} = await stripeElements.submit();
						if (submitError) {
							handleError(submitError);
							return;
						}

						const {error, paymentMethod} = await stripe.createPaymentMethod({
							elements: stripeElements
						});

						if (error) {
							handleError(error);
							return;
						}
						console.log(paymentMethod, 'Payment Method');
						if (paymentMethod) {
							// Determine endpoint and postData based on whether payment intent exists
							const isNewPaymentIntent = !pi_field || pi_field === '';
							const endpoint = isNewPaymentIntent ? '/Hotels/createPaymentIntent' : '/Hotels/updatePaymentIntent';

							const postData = isNewPaymentIntent
								? {
									amount           : amount,
									payment_method_id: paymentMethod.id,
								}
								: {
									payment_intent_id: pi_field,
									payment_method_id: paymentMethod.id,
								};

							console.log(postData, `${isNewPaymentIntent ? 'Create' : 'Update'} Payment Intent Post Data`);

							HE.Ajax.post(endpoint, postData)
								.then(function _handlePaymentIntent(data) {
									console.log(data, `${isNewPaymentIntent ? 'Create' : 'Update'} Payment return data`);
									if (data.payment_intent) {
										$('#hotelbooking-payment_intent').val(data.payment_intent);
										form.submit();
									}
								})
								.catch(function _paymentError(error) {
									handleError(error);
								});
						}
					} catch (error) {
						handleError(error);
					}
				} else {
					form.submit();
				}
			});

			function _resetSignatureClientId(pax_idx) {
				// reset everything
				$('#hotelbooking-pax-' + pax_idx + '-signature_client_id').val('');
				// $('#hotelbooking-pax-' + pax_idx + '-first_name').val('');
				// $('#hotelbooking-pax-' + pax_idx + '-last_name').val('');
				// $('#hotelbooking-pax-' + pax_idx + '-email').val('');

				// reset readonly
				$('#hotelbooking-pax-' + pax_idx + '-first_name').prop('readonly', false);
				$('#hotelbooking-pax-' + pax_idx + '-last_name').prop('readonly', false);
				$('#hotelbooking-pax-' + pax_idx + '-email').prop('readonly', false);
				$('#hotelbooking-pax-' + pax_idx + '-phone').prop('readonly', false);

				// toggle search/clear buttons
				$('.signature-clear-search[data-pax-idx="' + pax_idx + '"]').addClass('d-none');
				$('.signature-client-search[data-pax-idx="' + pax_idx + '"]').removeClass('d-none');
			}

			function _setSignatureClientId(data) {
				var pax_idx             = data.pax_idx,
					signature_client_id = data.signature_client_id,
					first_name          = data.first_name,
					last_name           = data.last_name,
					email               = data.email,
					phone               = data.phone;

				// set hidden field to signature client id
				$('#hotelbooking-pax-' + pax_idx + '-signature_client_id').val(signature_client_id);

				// set other fields
				$('#hotelbooking-pax-' + pax_idx + '-first_name').val(first_name);
				$('#hotelbooking-pax-' + pax_idx + '-last_name').val(last_name);
				$('#hotelbooking-pax-' + pax_idx + '-email').val(email);
				$('#hotelbooking-pax-' + pax_idx + '-phone').val(phone);

				// set to readonly if value returned
				if (first_name !== '') {
					$('#hotelbooking-pax-' + pax_idx + '-first_name').prop('readonly', true);
				}

				if (last_name !== '') {
					$('#hotelbooking-pax-' + pax_idx + '-last_name').prop('readonly', true);
				}

				if (email !== '') {
					$('#hotelbooking-pax-' + pax_idx + '-email').prop('readonly', true);
				}

				if (phone !== '') {
					$('#hotelbooking-pax-' + pax_idx + '-phone').prop('readonly', true);
				}

				// toggle search/clear buttons
				$('.signature-client-search[data-pax-idx="' + pax_idx + '"]').addClass('d-none');
				$('.signature-clear-search[data-pax-idx="' + pax_idx + '"]').removeClass('d-none');

				$('#signatureClient').offcanvas('hide');
			}

			function _getValidationErrorMessage(errors)
			{
				var error_string = '';

				if (typeof errors === 'string') {
					return HE.Form.buildProcessingError(errors);
				}

				error_string += '<ul>';

				$.each(errors, function onEachErrorMsg(i, field_info) {
					if (field_info.error) {
						error_string += '<li>' + field_info.error + '</li>';
					}
				});

				error_string += '</ul>';

				return error_string;
			}
			/* END signature specific logic */

			interval = setInterval(
				function _updateCurrentTimer() {
					// console.log(current_timer);

					$('#timer-val').html(fancyTimeFormat(parseFloat(max_time - current_timer)));

					if (current_timer >= max_time) {
						clearInterval(interval);

						HE.CustomConfirm({
							title  : 'Decision Time',
							content: 'You have been on this page longer than ' + fancyTimeFormat(max_time) + '. It is recommended to visit this hotel\'s details to re-select the room you would like to purchase. Would you like to view the rooms now?',
							confirm: function confirm() {
								document.location = HE.base_uri + '/Hotels/processor/selectHotel/' + $('#hotelbooking-giata_id').val();
							}
						});
					}

					current_timer++;
				},
				1000
			);

			function _checkMarkup(markup, selling_price)
			{
				// get what amount the markup is as a percentage of selling price
				var percentage  = ((markup/selling_price).toFixed(2)) * 100,
					markup_low  = $('#hotelbooking-markup_percentages').data('low'),
					markup_high = $('#hotelbooking-markup_percentages').data('high'),
					allowed     = true;

				if (percentage > markup_high) {
					allowed = false;
				} else if (percentage > markup_low && percentage <= markup_high) {
					HE.StatusMessage('info', "The amount of markup you provided is a bit higher than a normal percentage we expect (" + parseInt(markup_low) + "%). This is just a warning and the amount will be added.");

					allowed = true;
				} else {
					allowed = true;
				}

				return allowed;
			}

			function fancyTimeFormat(duration)
			{
				const hrs = ~~(duration / 3600);
				const mins = ~~((duration % 3600) / 60);
				const secs = ~~duration % 60;

				let ret = "";

				if (hrs > 0) {
					ret += "" + hrs + ":" + (mins < 10 ? "0" : ""); // eslint-disable-line no-implicit-coercion
				}

				ret += "" + mins + ":" + (secs < 10 ? "0" : "");  // eslint-disable-line no-implicit-coercion
				ret += "" + secs; // eslint-disable-line no-implicit-coercion

				return ret;
			}

			 function initializeStripe() {
				console.log('Initializing Stripe');
				let youPay = _getPayAmount();
				let amount = Math.round(youPay * 100);

				const paymentOptions = {
					mode                 : 'payment',
					amount               : amount,
					currency             : 'usd',
					paymentMethodCreation: 'manual',
					appearance           : {
						theme: 'flat',
					},
				 };

				const emailOptions   = {
					type: 'required'
				};


				const addressOptions = {
					mode  : 'billing',
					fields: {
						phone: 'always'
					},
					validation: {
						phone: {
							required: 'always',
						}
					}

				};

				stripeElements = stripe.elements(paymentOptions);

				const paymentElementOptions = {
					layout: 'accordion'
				};

				const paymentElement = stripeElements.create('payment', paymentElementOptions);
				const addressElement = stripeElements.create('address', addressOptions);
				const emailElement   = stripeElements.create('linkAuthentication', emailOptions);

				paymentElement.mount('#payment-element');
				addressElement.mount('#address-element');
				emailElement.mount('#email-element');
			}

			function deinitializeStripe() {
					// Clear the DOM elements
					$('#payment-element').empty();
					$('#address-element').empty();
					$('#email-element').empty();

					// Destroy the Stripe elements instance
					stripeElements = null;

			}
		});

    });
}(jQuery, window.HE || {}));
